import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, PayRate, PayRateWrite } from 'types';
import { client } from 'utils/api-client';

export default function useUpdatePayRate(): UseMutationResult<
  AxiosResponse<PayRate>,
  AxiosError<ErrorMessage>,
  PayRateWrite
> {
  const queryClient = useQueryClient();

  const updatePayRate = (payRate: PayRateWrite): Promise<AxiosResponse<PayRate>> => {
    return client.put(`pay-rates/${payRate.payRateId}/`, payRate);
  };

  return useMutation(updatePayRate, {
    onSuccess: () => {
      queryClient.invalidateQueries('payRates');
    },
  });
}
